import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { ArticlePage } from './components/article/ArticlePage';
import { Layout } from './components/layout/Layout';
import { RoleTopPage } from './components/top/RoleTopPage';
import { TopPage } from './components/top/TopPage';
import { getAllArticles } from './content/registry';

const ReleaseNotes = lazy(() => import('./content/ReleaseNotesPage'));

export default function App() {
  const articles = getAllArticles();

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<TopPage />} />
          <Route path='/manager' element={<RoleTopPage role='manager' />} />
          <Route path='/member' element={<RoleTopPage role='member' />} />
          <Route path='/admin' element={<RoleTopPage role='admin' />} />
          <Route
            path='/release-notes'
            element={
              <ArticlePage title='リリースノート'>
                <Suspense>
                  <ReleaseNotes />
                </Suspense>
              </ArticlePage>
            }
          />
          {articles.map((article) => (
            <Route
              key={article.id}
              path={article.path}
              element={
                <ArticlePage title={article.title}>
                  <article.component />
                </ArticlePage>
              }
            />
          ))}
          <Route path='*' element={<Navigate to='/' replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
